export function camelCaseToCapitalCase(string){
    if(!string || typeof string != 'string') return string;
    return string.replace(/([A-Z])/g, ' $1') // insert a space before all caps
    .replace(/^./, function(str){ return str.toUpperCase(); }) // uppercase the first character
}

export function toCapitalCase(string){
    if(!string || typeof string != 'string') return string;
    return string.toLowerCase() //lowercase all
    .replace(/^./, function(c){ return c.toUpperCase(); }) // uppercase the first character
}
export function toCapitalCaseAll(string){
    if(!string || typeof string != 'string') return string;
    return string.toLowerCase() //lowercase all
    .replace(/\b\w/g, function(c){ return c.toUpperCase(); }) // uppercase the first character of each word
}
export function joinAsCamelCase(arr){
    if(!Array.isArray(arr)) return null;
    if(!arr.length) return '';
    let out = '';
    for(let i = 1; i < arr.length; i++){
        out += (arr[i] + '').toLowerCase().replace(/\s/g,'').replace(/\b\w/g, c=>c.toUpperCase())
    }
    out = (arr[0] + '').toLowerCase() + out;
    return out;
}